import { useState, useEffect } from 'react';
import { isEmailValid } from '../../utils/Validator';
import TextInput from './TextInput';

const EmailInput = ({
  value,
  onChange,
  onValidationChange,
  disabled = false,
  placeholder = 'Email',
  ...props
}) => {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    const valid = isEmailValid(value);
    setIsValid(valid);
    if (onValidationChange) {
      onValidationChange(valid);
    }
  }, [value, onValidationChange]);

  return (
    <TextInput
      type="email"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={30}
      disabled={disabled}
      isValid={isValid}
      {...props}
    />
  );
};

export default EmailInput;
